import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

export default function FooterTable({ total }: { total?: number }) {
  return (
    <Flex bg={colors.black75} roundedBottom={15} px={4} h="50px" align="center">
      {total ? (
        <Flex  fontWeight="medium">
          {total} {total > 1 ? "items" : "item"}
        </Flex>
      ) : null}
    </Flex>
  );
}
